export default "__VITE_ASSET__B1nJHEi1__"